<template>
	<div class="row race-entries">
		<div class="small-12 columns">
			<ul class="inline serif separated">
				<li v-if="race.purse">Purse: <strong>{{ race.purse | currency }}</strong></li>
				<li v-if="race.distance">Distance: <strong>{{ race.distance }}</strong></li>
				<li v-if="race.age_restriction">Age: <strong>{{ race.age_restriction }}</strong></li>
				<li v-if="race.surface">Surface: <strong>{{ race.surface }}</strong></li>
			</ul>
			<div class="black-header thin text-center"><span class="inactive">Entries</span></div>
		</div>
		<div v-for="start in starts" v-if="start.horse" class="small-12 medium-6 large-4 columns">
			<entry :entry="start" :race="race"></entry>
		</div>
	</div>
	<div class="row">
		<div class="small-12 columns">
			<a :href="race.url" class="expanded button">More Detail</a>
		</div>
	</div>
</template>

<script>
	import Entry from './Entry.vue'
	import _ from 'underscore'
	export default {
		components: { Entry },
		props: [ 'race' ],
		asyncData () {
			return this.race.loadRelationship('start').then(function () {
				return {};
			});
		},
		computed: {
			starts () {
				if (this.race.field_status == 1) {
					return _.sortBy(this.race.start, function (start) {
						if (!start.horse) return null;
						return start.horse.title;
					});
				} else if (this.race.field_status == 2 || this.race.field_status == 4) {
					return _.sortBy(this.race.start, function (start) {
						return parseInt(start.program_number, 10);
					});
				}
			}
		}
	}
</script>



/** WEBPACK FOOTER **
 ** RaceEntries.vue?637413a5
 **/